export const yyyymmdd =
  /^\d{4}-((((0[13578])|([13578])|(1[02]))-(([1-9])|([0-2][0-9])|(3[01])))|(((0[469])|([469])|(11))-(([1-9])|([0-2][0-9])|(30)))|((2|02)-(([1-9])|([0-2][0-9]))))$/
export const hhmm = /^([0-1][0-9]|[2][0-3]):([0-5][0-9])$/
